import type { GetStaticPaths, GetStaticProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { dehydrate, QueryClient } from "@tanstack/react-query";
import { getDLanguages, getDSetting } from "api/developmentResearchUser";
import { TIME_REVALIDATE } from "config/info";
import { getDoctorsDetail } from "api/main";
import { DoctorDetais } from "components/MainPage/VisitorsGuide/DoctorDetails";

const DoctorDetaisPage: NextPage = () => {
  return (
    <>
      <DoctorDetais />
    </>
  );
};

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => {
  return {
    paths: [], //indicates that no page needs be created at build time
    fallback: "blocking", //indicates the type of fallback
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const locale = context.locale as string;
  const queryClient = new QueryClient();
  const id = parseInt(context.params?.id as string);

  const requests = [
    queryClient.prefetchQuery(["getDLanguages", locale], () => getDLanguages(locale)),
    queryClient.prefetchQuery(["getMSetting", locale, "site"], () => getDSetting(locale, "site")),
    queryClient.prefetchQuery(["getDoctorsDetail", locale, id], () =>
      getDoctorsDetail({ id, locale })
    ),
  ];

  await Promise.all(requests);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      ...(await serverSideTranslations(locale || "", ["common"])),
    },
    revalidate: TIME_REVALIDATE,
  };
};

export default DoctorDetaisPage;
